// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn[data-v-0d86014e]{border-radius:3px;margin:0}.AdminImageVault-img-area[data-v-0d86014e]{float:left;color:#fff;font-size:11px;position:relative;padding:10px}.AdminImageVault-img-area img[data-v-0d86014e]{cursor:pointer;padding:5px;margin:auto;height:200px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
